import { render, staticRenderFns } from "./returnRecord.vue?vue&type=template&id=7a363901&scoped=true"
import script from "./returnRecord.vue?vue&type=script&lang=js"
export * from "./returnRecord.vue?vue&type=script&lang=js"
import style0 from "./returnRecord.vue?vue&type=style&index=0&id=7a363901&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a363901",
  null
  
)

export default component.exports